import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { DocumentFileUrlUpdateRequest } from "apis/data-contracts";

export interface UpdateDocumentFileUrlParams {
  uuid: string;
  data: DocumentFileUrlUpdateRequest;
}

const useUpdateDocumentFileUrl = () => {
  return useMutation({
    mutationFn: ({ uuid, data }: UpdateDocumentFileUrlParams) =>
      api.document.updateDocumentFileUrl(uuid, data),
  });
};

export default useUpdateDocumentFileUrl;
